export default {
  isPropTradingAccount: false, // user from official PT page or user had applied for PT sessions
  session: false,
  eligible: false,
  account: false,
  hasActiveAccounts: false,
  isRefetch:true
}
